const TeamNameStacking = {
    TEAM_NAME_STACKING_SET_DATA_FROM_STORAGE: 'TEAM_NAME_STACKING_SET_DATA_FROM_STORAGE',
    TEAM_NAME_STACKING_SET_IS_USED: 'TEAM_NAME_STACKING_SET_IS_USED',
    TEAM_NAME_STACKING_SET_IS_WIDGET_HIDDEN: 'TEAM_NAME_STACKING_SET_IS_WIDGET_HIDDEN',
    TEAM_NAME_STACKING_SET_TEAM_OPTIONS: 'TEAM_NAME_STACKING_SET_TEAM_OPTIONS',
    TEAM_NAME_STACKING_SET_ALL_TEAM_OPTIONS_ENABLED_STATUS: 'TEAM_NAME_STACKING_SET_ALL_TEAM_OPTIONS_ENABLED_STATUS',
    TEAM_NAME_STACKING_SET_MAX_PLAYERS_FOR_TEAMS: 'TEAM_NAME_STACKING_SET_MAX_PLAYERS_FOR_TEAMS',
};

export default TeamNameStacking;
